import React, { useState } from 'react'
import { UsageCharts } from "../charts"

import { ProjectsOverview, ProjectsPerformance } from "../components"
import { useSelector } from 'react-redux'

const Stats = ({ projectsUsage, filtered }) => {
    return <div className="flex w-full metrics-stats">
        <div className="projects-overview mr-2 w-full md:max-w-[100%] lg:max-w-[50%] xl:max-w-[100%]">
            <ProjectsOverview filtered={filtered}></ProjectsOverview>
        </div>
        <div className="projects-performance w-full lg:max-w-[50%] xl:max-w-[100%]">
            <ProjectsPerformance filtered={filtered}></ProjectsPerformance>
        </div>
    </div>
}

const Charts = ({ projectsUsage, filtered }) => {
    const [showExclusion, setShowExclusion] = useState(false)
    const handleSelection = (e) => {
        if (e.target.value == "exclusion") setShowExclusion(true)
        else setShowExclusion(false)
    }
    if (projectsUsage.sortedDates.length < 2) return ""
    return <div className="charts-graph-container coverage-chart flex h-[332px] min-w-[350px] flex md:w-[50%] flex-col px-4 py-2 w-full  bg-slate-50 rounded-md shadow-md ml-2">
        <div className="flex justify-between items-center">
            {!showExclusion ? <h1 className="text-sm text-slate-600 font-semibold">Meterian usage overtime</h1>
                : <h1 className="text-sm text-slate-600 font-semibold">Exclusion usage overtime</h1>}
            <div className="">
                <select onChange={handleSelection} name="charts" id="charts-select" className="bg-transparent text-slate-600 w-24 border-none hover:cursor-pointer">
                    <option className="bg-slate-300" value="coverage">Coverage</option>
                    <option className="bg-slate-300" value="exclusion">Exclusions</option>
                </select>
            </div>

        </div>

        <div className="flex justify-center gap-4 text-xs text-slate-600 mt-2">
            {!showExclusion ? <>
                <div className="flex gap-1 items-center">
                    <span className="w-4 h-1 rounded-[5px] bg-blue-400 "></span>
                    <h1>Projects</h1>
                </div>
                <div className="flex gap-1 items-center">
                    <span className="w-4 h-1 rounded-[5px] bg-red-400 "></span>
                    <h1>Analyses</h1>
                </div>
            </> : <div className="flex gap-1 items-center">
                <span className="w-4 h-1 rounded-[5px] bg-blue-400 "></span>
                <h1>Exclusions</h1>
            </div>}
        </div>
        <div className="charts flex h-full max-h-[288px]">
            <UsageCharts showExclusion={showExclusion} filtered = {filtered}></UsageCharts>
        </div>
    </div>

}

const Overview = ({ projectsUsage, filteredProjectsUsage }) => {
    
    const { searchFilter } = useSelector((state) => state.projects)

    let usageData = projectsUsage
    if(searchFilter && searchFilter.length) usageData = filteredProjectsUsage


    return <>
        <div className='flex'>
            <h1 className="mb-2 me-5 text-xl font-semibold text-left">Metrics</h1> 

        </div>

        <div className="charts-container flex w-full">
            <Stats projectsUsage={usageData} filtered={searchFilter}/>
            <Charts projectsUsage={usageData} filtered={searchFilter}/>
        </div>
    </>
}

export default Overview

